<template>
  <div class="layout-fixed-header">
    <div class="header-nav-wrap" ref="headerWrap">
      <!--      <InviteBanner/>-->
      <div class="PublicHeader" id="HomeHeaderFixed">
        <PublicHeader
          id="Header"
          :params="params"
          :new-search-keyword="searchKeyword"
          :is-show-search="isShowSearch"
          class="header"
          @toMaterialList="toMaterialList"
          :picList="picList"
          :festivalList="festivalList"
          :solarTermsList="solarTermsList"
          :recommendList="recommendList"

          :threeDCategoryList="threeDCategoryList"
          :threeDRecommendList="threeDRecommendList"
          :festivalData="festivalData"
          :styleCategoryList="styleCategoryList"
          :styleRecommendList="styleRecommendList"
        />
      </div>
    </div>
    <div class="header-nav-wrap-placeholder" :style=" 'height: '+ 80 + 'px'"/>

    <nuxt/>
    <Footer />
    <GlobalSlot/>

    <no-ssr>
      <Login/>

      <Sidebar/>
      <PublicSlot />

      <!-- 新用户登录免费下载引导提示弹框 -->
      <!-- <NewUserFreeDownGuideModal/> -->
    </no-ssr>
  </div>

</template>

<script>
import {PublicHeader, Footer, Login} from "@/components/common/index.js"
import {InviteBanner} from "@/components/act/invite/index.js"
import {mapGetters} from "vuex";
import {getMaterialList} from "../api/material";
import {ObjectToArray} from "~/components/list/module";
import FeedbackBuoy from '@/components/common/feedback-buoy/feedback-buoy'
import PartTimeIcon from '@/components/common/part-time-icon';
import Sidebar from '@/components/common/sidebar'
import GlobalSlot from '@/components/common/global-slot'
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import {getDropdownByDesignStyle, getDropdownByFestival, getDropdownByHot, getDropdownByThreeD} from "@/api/nav";
import NewUserFreeDownGuideModal from "@/components/_components/home/NewUserFreeDownGuideModal";
import {getDropDownByAll} from "~/api/home";

import PublicSlot from "@/components/_Public/PublicSlot";


export default {
  name: "HeaderNav",
  components: {
    PublicHeader,
    InviteBanner,
    Footer,
    Login,
    FeedbackBuoy,
    PartTimeIcon,
    Sidebar,
    GlobalSlot,
    NewUserFreeDownGuideModal,

    PublicSlot
  },
  data() {
    return {
      isShow: false,
      params: {
        pinyin: 0,
        home_keyword_id: 0,
        layout: 0,
        time_filter: 0,
        module: 0,
        desc: "default",
        page: 1,
      },
      searchKeyword: "",
      isShowSearch: false,
      picList: [],
      festivalList: [],
      solarTermsList: [],
      recommendList: [],
      threeDCategoryList: [],
      threeDRecommendList: [],
      festivalData: {},
      styleRecommendList: [],
      styleCategoryList: [],
    }
  },
  computed: {
    ...mapGetters('layout', ['screenWidth', 'bannerHeight'])
  },

  async fetch() {
    const cache = this.$nuxt.$options.fetchCache
    const cacheKey = 'header-nav';
    const navHotKey = 'navHotKey';  // 全部下拉
    const navThreeDKey = 'navThreeDKey';  // 全部下拉

    // 从缓存中读取数据
    // const cachedData = cache.get(navHotKey)

    // console.log('----cachedData')
    // console.log(cachedData)

    /*if (cachedData) {
      // 如果缓存中有数据，直接使用缓存的数据
      this.myData = cachedData
    } else {
      // 如果缓存中没有数据，从服务器端获取数据
      const response = await this.$axios.get('/api/my-data')

      // 将获取到的数据存入缓存中
      cache.set(cacheKey, response.data)

      // 使用获取到的数据
      this.myData = response.data
    }*/


    /* -- 获取热点下拉数据 */
   /* const {data} = await getDropdownByHot();
    let {pic, marketing_festival, twenty_festival, content} = data.data;

    this.picList = pic.length > 5 ? pic.slice(0, 5) : pic;
    this.festivalList = marketing_festival.length > 5 ? marketing_festival.slice(0, 5) : marketing_festival;
    this.solarTermsList = twenty_festival.length > 5 ? twenty_festival.slice(0, 5) : twenty_festival;

    let arr = [];
    for (let i = 0; i < content.length; i += 5) {
      arr.push(content.slice(i, i + 5));
    }
    this.recommendList = arr;


    /!* __ 3D 下拉 *!/
    let threeDRes = await getDropdownByThreeD();
    this.threeDCategoryList = threeDRes.data.data.category;
    this.threeDRecommendList = threeDRes.data.data.recommend;

    /!* __ 节日节气 下拉 *!/
    const festivalRes = await getDropdownByFestival();
    this.festivalData = festivalRes.data.data;

    /!* __设计风格 下拉 *!/

    const designStyleRes = await getDropdownByDesignStyle()
    this.styleCategoryList = designStyleRes.data.data.design;
    this.styleRecommendList = designStyleRes.data.data.recommendPic;*/


  },
  sliceList(list) {
    let tempList = list.length > 5 ? list.slice(0, 5) : list;
    return tempList.filter(vo => vo != null);
  },
  averageRecommendList(data) {
    let arr = [];
    for (let i = 0; i < data.length; i += 5) {
      arr.push(data.slice(i, i + 5));
    }
    return arr;
  },
  mounted() {
    // let bannerHeight = this.$refs.headerWrap.offsetHeight
    // this.bannerHeight = bannerHeight
    // this.$store.commit('layout/SET_BANNER_HEIGHT', bannerHeight)

    let whiteList = [
      PAGE_PATH.TU_PIAN.DETAIL,
      PAGE_PATH.TU_PIAN.LIST,
      PAGE_PATH.TOPIC.COLLECTION
    ];

    for (let i = 0; i < whiteList.length; i++) {
      if (this.$route.path.indexOf(whiteList[i]) > -1) {
        this.isShowSearch = true
        break;
      } else {
        this.isShowSearch = false;
      }
    }
    if (this.$route.path.indexOf(PAGE_PATH.TU_PIAN.DETAIL) > -1) {
      this.$store.commit('base/SET_SEARCH_VAL', '')
    }

    this.getDropDownByALL();

  }
  ,
  methods: {
    getDropDownByALL(){
      getDropDownByAll().then(res =>{
        console.log(res)
        const { status , data } = res.data;
        if(status == 1){
          this.$store.commit('_Public/Header/setDropDownDataByAll',data)
        }
      })

    },
    toMaterialList(path) {
      if (this.$route.path.indexOf('/list') > -1) {
        this.materialList = [];
        this.getMaterialList(this.params)
      } else {

      }
    }
    ,
    getMaterialList(tempParams) {
      getMaterialList(tempParams).then(res => {
        let {list, keyword, total_page} = res.data;
        this.searchKeyword = keyword;
        if (Array.isArray(list) && list.length === 0) {
          this.materialList = [];
          this.reqState = false
        } else {
          this.materialList = ObjectToArray(list);
          this.reqState = true
        }
      })
    }
    ,
  }
}
</script>

<style lang="scss" scoped>
@import "components/common/header/common/header";

.header-nav-wrap {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 998;
}


#HomeHeaderFixed {
  top: 0 !important;
}
</style>


<!--
  Readme
  含固定头部和底部
-->

